const THEMES = {
  CLARO: 'CLARO',
  OSCURO: 'OSCURO',
  COLOR: 'UNICORN',
};

export default THEMES;
